export const ColorTokens = {
  "palette": {
    "black": {
      "value": "#000000",
      "attributes": {
        "category": "color",
        "type": "black"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#000000",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteBlack",
      "path": [
        "palette",
        "black"
      ]
    },
    "white": {
      "value": "#ffffff",
      "attributes": {
        "category": "color",
        "type": "white"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#ffffff",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteWhite",
      "path": [
        "palette",
        "white"
      ]
    },
    "red": {
      "value": "#ee0000",
      "attributes": {
        "category": "color",
        "type": "red"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#ee0000",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteRed",
      "path": [
        "palette",
        "red"
      ]
    },
    "gray95": {
      "value": "#f6f6f6",
      "attributes": {
        "category": "color",
        "type": "gray95"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#f6f6f6",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteGray95",
      "path": [
        "palette",
        "gray95"
      ]
    },
    "gray85": {
      "value": "#d8dada",
      "attributes": {
        "category": "color",
        "type": "gray85"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#d8dada",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteGray85",
      "path": [
        "palette",
        "gray85"
      ]
    },
    "gray65": {
      "value": "#a7a7a7",
      "attributes": {
        "category": "color",
        "type": "gray65"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#a7a7a7",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteGray65",
      "path": [
        "palette",
        "gray65"
      ]
    },
    "gray44": {
      "value": "#6f7171",
      "attributes": {
        "category": "color",
        "type": "gray44"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#6f7171",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteGray44",
      "path": [
        "palette",
        "gray44"
      ]
    },
    "gray20": {
      "value": "#333333",
      "attributes": {
        "category": "color",
        "type": "gray20"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#333333",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteGray20",
      "path": [
        "palette",
        "gray20"
      ]
    },
    "gray11": {
      "value": "#1b1d1f",
      "attributes": {
        "category": "color",
        "type": "gray11"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#1b1d1f",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteGray11",
      "path": [
        "palette",
        "gray11"
      ]
    },
    "orange91": {
      "value": "#fbe4d7",
      "attributes": {
        "category": "color",
        "type": "orange91"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#fbe4d7",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteOrange91",
      "path": [
        "palette",
        "orange91"
      ]
    },
    "orange46": {
      "value": "#ed7000",
      "attributes": {
        "category": "color",
        "type": "orange46"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#ed7000",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteOrange46",
      "path": [
        "palette",
        "orange46"
      ]
    },
    "orange39": {
      "value": "#c44904",
      "attributes": {
        "category": "color",
        "type": "orange39"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#c44904",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteOrange39",
      "path": [
        "palette",
        "orange39"
      ]
    },
    "orange15": {
      "value": "#4a1c02",
      "attributes": {
        "category": "color",
        "type": "orange15"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#4a1c02",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteOrange15",
      "path": [
        "palette",
        "orange15"
      ]
    },
    "yellow94": {
      "value": "#fff4e0",
      "attributes": {
        "category": "color",
        "type": "yellow94"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#fff4e0",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteYellow94",
      "path": [
        "palette",
        "yellow94"
      ]
    },
    "yellow62": {
      "value": "#ffbc3d",
      "attributes": {
        "category": "color",
        "type": "yellow62"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#ffbc3d",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteYellow62",
      "path": [
        "palette",
        "yellow62"
      ]
    },
    "yellow20": {
      "value": "#523c14",
      "attributes": {
        "category": "color",
        "type": "yellow20"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#523c14",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteYellow20",
      "path": [
        "palette",
        "yellow20"
      ]
    },
    "blue91": {
      "value": "#d6eefb",
      "attributes": {
        "category": "color",
        "type": "blue91"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#d6eefb",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteBlue91",
      "path": [
        "palette",
        "blue91"
      ]
    },
    "blue45": {
      "value": "#0096e4",
      "attributes": {
        "category": "color",
        "type": "blue45"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#0096e4",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteBlue45",
      "path": [
        "palette",
        "blue45"
      ]
    },
    "blue35": {
      "value": "#0077b4",
      "attributes": {
        "category": "color",
        "type": "blue35"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#0077b4",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteBlue35",
      "path": [
        "palette",
        "blue35"
      ]
    },
    "blue13": {
      "value": "#002b42",
      "attributes": {
        "category": "color",
        "type": "blue13"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#002b42",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteBlue13",
      "path": [
        "palette",
        "blue13"
      ]
    },
    "green89": {
      "value": "#d6f2e0",
      "attributes": {
        "category": "color",
        "type": "green89"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#d6f2e0",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteGreen89",
      "path": [
        "palette",
        "green89"
      ]
    },
    "green26": {
      "value": "#008330",
      "attributes": {
        "category": "color",
        "type": "green26"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#008330",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteGreen26",
      "path": [
        "palette",
        "green26"
      ]
    },
    "green34": {
      "value": "#00ac3e",
      "attributes": {
        "category": "color",
        "type": "green34"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#00ac3e",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteGreen34",
      "path": [
        "palette",
        "green34"
      ]
    },
    "green11": {
      "value": "#003614",
      "attributes": {
        "category": "color",
        "type": "green11"
      },
      "filePath": "packages/Color/src/index.js",
      "isSource": true,
      "original": {
        "value": "#003614",
        "attributes": {
          "category": "color"
        }
      },
      "name": "PaletteGreen11",
      "path": [
        "palette",
        "green11"
      ]
    }
  },
  "background": {
    "primary": {
      "light": {
        "value": "#ffffff",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "light"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#ffffff",
          "attributes": {
            "category": "color"
          }
        },
        "name": "BackgroundPrimaryLight",
        "path": [
          "background",
          "primary",
          "light"
        ]
      },
      "dark": {
        "value": "#000000",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "dark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#000000",
          "attributes": {
            "category": "color"
          }
        },
        "name": "BackgroundPrimaryDark",
        "path": [
          "background",
          "primary",
          "dark"
        ]
      }
    },
    "secondary": {
      "light": {
        "value": "#f6f6f6",
        "attributes": {
          "category": "color",
          "type": "secondary",
          "item": "light"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#f6f6f6",
          "attributes": {
            "category": "color"
          }
        },
        "name": "BackgroundSecondaryLight",
        "path": [
          "background",
          "secondary",
          "light"
        ]
      },
      "dark": {
        "value": "#1b1d1f",
        "attributes": {
          "category": "color",
          "type": "secondary",
          "item": "dark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#1b1d1f",
          "attributes": {
            "category": "color"
          }
        },
        "name": "BackgroundSecondaryDark",
        "path": [
          "background",
          "secondary",
          "dark"
        ]
      }
    }
  },
  "feedback": {
    "error": {
      "onlight": {
        "value": "#c44904",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "onlight"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#c44904",
          "attributes": {
            "category": "color"
          }
        },
        "name": "FeedbackErrorOnlight",
        "path": [
          "feedback",
          "error",
          "onlight"
        ]
      },
      "ondark": {
        "value": "#ed7000",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "ondark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#ed7000",
          "attributes": {
            "category": "color"
          }
        },
        "name": "FeedbackErrorOndark",
        "path": [
          "feedback",
          "error",
          "ondark"
        ]
      },
      "background": {
        "onlight": {
          "value": "#fbe4d7",
          "attributes": {
            "category": "color",
            "type": "error",
            "item": "background",
            "subitem": "onlight"
          },
          "filePath": "packages/Color/src/index.js",
          "isSource": true,
          "original": {
            "value": "#fbe4d7",
            "attributes": {
              "category": "color"
            }
          },
          "name": "FeedbackErrorBackgroundOnlight",
          "path": [
            "feedback",
            "error",
            "background",
            "onlight"
          ]
        },
        "ondark": {
          "value": "#4a1c02",
          "attributes": {
            "category": "color",
            "type": "error",
            "item": "background",
            "subitem": "ondark"
          },
          "filePath": "packages/Color/src/index.js",
          "isSource": true,
          "original": {
            "value": "#4a1c02",
            "attributes": {
              "category": "color"
            }
          },
          "name": "FeedbackErrorBackgroundOndark",
          "path": [
            "feedback",
            "error",
            "background",
            "ondark"
          ]
        }
      }
    },
    "warning": {
      "onlight": {
        "value": "#ffbc3d",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "onlight"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#ffbc3d",
          "attributes": {
            "category": "color"
          }
        },
        "name": "FeedbackWarningOnlight",
        "path": [
          "feedback",
          "warning",
          "onlight"
        ]
      },
      "ondark": {
        "value": "#ffbc3d",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "ondark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#ffbc3d",
          "attributes": {
            "category": "color"
          }
        },
        "name": "FeedbackWarningOndark",
        "path": [
          "feedback",
          "warning",
          "ondark"
        ]
      },
      "background": {
        "onlight": {
          "value": "#fff4e0",
          "attributes": {
            "category": "color",
            "type": "warning",
            "item": "background",
            "subitem": "onlight"
          },
          "filePath": "packages/Color/src/index.js",
          "isSource": true,
          "original": {
            "value": "#fff4e0",
            "attributes": {
              "category": "color"
            }
          },
          "name": "FeedbackWarningBackgroundOnlight",
          "path": [
            "feedback",
            "warning",
            "background",
            "onlight"
          ]
        },
        "ondark": {
          "value": "#523c14",
          "attributes": {
            "category": "color",
            "type": "warning",
            "item": "background",
            "subitem": "ondark"
          },
          "filePath": "packages/Color/src/index.js",
          "isSource": true,
          "original": {
            "value": "#523c14",
            "attributes": {
              "category": "color"
            }
          },
          "name": "FeedbackWarningBackgroundOndark",
          "path": [
            "feedback",
            "warning",
            "background",
            "ondark"
          ]
        }
      }
    },
    "information": {
      "onlight": {
        "value": "#0077b4",
        "attributes": {
          "category": "color",
          "type": "information",
          "item": "onlight"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#0077b4",
          "attributes": {
            "category": "color"
          }
        },
        "name": "FeedbackInformationOnlight",
        "path": [
          "feedback",
          "information",
          "onlight"
        ]
      },
      "ondark": {
        "value": "#0096e4",
        "attributes": {
          "category": "color",
          "type": "information",
          "item": "ondark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#0096e4",
          "attributes": {
            "category": "color"
          }
        },
        "name": "FeedbackInformationOndark",
        "path": [
          "feedback",
          "information",
          "ondark"
        ]
      },
      "background": {
        "onlight": {
          "value": "#d6eefb",
          "attributes": {
            "category": "color",
            "type": "information",
            "item": "background",
            "subitem": "onlight"
          },
          "filePath": "packages/Color/src/index.js",
          "isSource": true,
          "original": {
            "value": "#d6eefb",
            "attributes": {
              "category": "color"
            }
          },
          "name": "FeedbackInformationBackgroundOnlight",
          "path": [
            "feedback",
            "information",
            "background",
            "onlight"
          ]
        },
        "ondark": {
          "value": "#002b42",
          "attributes": {
            "category": "color",
            "type": "information",
            "item": "background",
            "subitem": "ondark"
          },
          "filePath": "packages/Color/src/index.js",
          "isSource": true,
          "original": {
            "value": "#002b42",
            "attributes": {
              "category": "color"
            }
          },
          "name": "FeedbackInformationBackgroundOndark",
          "path": [
            "feedback",
            "information",
            "background",
            "ondark"
          ]
        }
      }
    },
    "success": {
      "onlight": {
        "value": "#008330",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "onlight"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#008330",
          "attributes": {
            "category": "color"
          }
        },
        "name": "FeedbackSuccessOnlight",
        "path": [
          "feedback",
          "success",
          "onlight"
        ]
      },
      "ondark": {
        "value": "#00ac3e",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "ondark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#00ac3e",
          "attributes": {
            "category": "color"
          }
        },
        "name": "FeedbackSuccessOndark",
        "path": [
          "feedback",
          "success",
          "ondark"
        ]
      },
      "background": {
        "onlight": {
          "value": "#d6f2e0",
          "attributes": {
            "category": "color",
            "type": "success",
            "item": "background",
            "subitem": "onlight"
          },
          "filePath": "packages/Color/src/index.js",
          "isSource": true,
          "original": {
            "value": "#d6f2e0",
            "attributes": {
              "category": "color"
            }
          },
          "name": "FeedbackSuccessBackgroundOnlight",
          "path": [
            "feedback",
            "success",
            "background",
            "onlight"
          ]
        },
        "ondark": {
          "value": "#003614",
          "attributes": {
            "category": "color",
            "type": "success",
            "item": "background",
            "subitem": "ondark"
          },
          "filePath": "packages/Color/src/index.js",
          "isSource": true,
          "original": {
            "value": "#003614",
            "attributes": {
              "category": "color"
            }
          },
          "name": "FeedbackSuccessBackgroundOndark",
          "path": [
            "feedback",
            "success",
            "background",
            "ondark"
          ]
        }
      }
    }
  },
  "interactive": {
    "active": {
      "onlight": {
        "value": "#6f7171",
        "attributes": {
          "category": "color",
          "type": "active",
          "item": "onlight"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#6f7171",
          "attributes": {
            "category": "color"
          }
        },
        "name": "InteractiveActiveOnlight",
        "path": [
          "interactive",
          "active",
          "onlight"
        ]
      },
      "ondark": {
        "value": "#a7a7a7",
        "attributes": {
          "category": "color",
          "type": "active",
          "item": "ondark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#a7a7a7",
          "attributes": {
            "category": "color"
          }
        },
        "name": "InteractiveActiveOndark",
        "path": [
          "interactive",
          "active",
          "ondark"
        ]
      }
    },
    "disabled": {
      "onlight": {
        "value": "#d8dada",
        "attributes": {
          "category": "color",
          "type": "disabled",
          "item": "onlight"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#d8dada",
          "attributes": {
            "category": "color"
          }
        },
        "name": "InteractiveDisabledOnlight",
        "path": [
          "interactive",
          "disabled",
          "onlight"
        ]
      },
      "ondark": {
        "value": "#333333",
        "attributes": {
          "category": "color",
          "type": "disabled",
          "item": "ondark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#333333",
          "attributes": {
            "category": "color"
          }
        },
        "name": "InteractiveDisabledOndark",
        "path": [
          "interactive",
          "disabled",
          "ondark"
        ]
      }
    },
    "scrollthumb": {
      "onlight": {
        "value": "#6f7171",
        "attributes": {
          "category": "color",
          "type": "scrollthumb",
          "item": "onlight"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#6f7171",
          "attributes": {
            "category": "color"
          }
        },
        "name": "InteractiveScrollthumbOnlight",
        "path": [
          "interactive",
          "scrollthumb",
          "onlight"
        ]
      },
      "ondark": {
        "value": "#a7a7a7",
        "attributes": {
          "category": "color",
          "type": "scrollthumb",
          "item": "ondark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#a7a7a7",
          "attributes": {
            "category": "color"
          }
        },
        "name": "InteractiveScrollthumbOndark",
        "path": [
          "interactive",
          "scrollthumb",
          "ondark"
        ]
      },
      "hover": {
        "onlight": {
          "value": "#333333",
          "attributes": {
            "category": "color",
            "type": "scrollthumb",
            "item": "hover",
            "subitem": "onlight"
          },
          "filePath": "packages/Color/src/index.js",
          "isSource": true,
          "original": {
            "value": "#333333",
            "attributes": {
              "category": "color"
            }
          },
          "name": "InteractiveScrollthumbHoverOnlight",
          "path": [
            "interactive",
            "scrollthumb",
            "hover",
            "onlight"
          ]
        },
        "ondark": {
          "value": "#d8dada",
          "attributes": {
            "category": "color",
            "type": "scrollthumb",
            "item": "hover",
            "subitem": "ondark"
          },
          "filePath": "packages/Color/src/index.js",
          "isSource": true,
          "original": {
            "value": "#d8dada",
            "attributes": {
              "category": "color"
            }
          },
          "name": "InteractiveScrollthumbHoverOndark",
          "path": [
            "interactive",
            "scrollthumb",
            "hover",
            "ondark"
          ]
        }
      }
    },
    "scrolltrack": {
      "onlight": {
        "value": "#d8dada",
        "attributes": {
          "category": "color",
          "type": "scrolltrack",
          "item": "onlight"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#d8dada",
          "attributes": {
            "category": "color"
          }
        },
        "name": "InteractiveScrolltrackOnlight",
        "path": [
          "interactive",
          "scrolltrack",
          "onlight"
        ]
      },
      "ondark": {
        "value": "#333333",
        "attributes": {
          "category": "color",
          "type": "scrolltrack",
          "item": "ondark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#333333",
          "attributes": {
            "category": "color"
          }
        },
        "name": "InteractiveScrolltrackOndark",
        "path": [
          "interactive",
          "scrolltrack",
          "ondark"
        ]
      }
    }
  },
  "elements": {
    "primary": {
      "onlight": {
        "value": "#000000",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "onlight"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#000000",
          "attributes": {
            "category": "color"
          }
        },
        "name": "ElementsPrimaryOnlight",
        "path": [
          "elements",
          "primary",
          "onlight"
        ]
      },
      "ondark": {
        "value": "#ffffff",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "ondark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#ffffff",
          "attributes": {
            "category": "color"
          }
        },
        "name": "ElementsPrimaryOndark",
        "path": [
          "elements",
          "primary",
          "ondark"
        ]
      }
    },
    "secondary": {
      "onlight": {
        "value": "#6f7171",
        "attributes": {
          "category": "color",
          "type": "secondary",
          "item": "onlight"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#6f7171",
          "attributes": {
            "category": "color"
          }
        },
        "name": "ElementsSecondaryOnlight",
        "path": [
          "elements",
          "secondary",
          "onlight"
        ]
      },
      "ondark": {
        "value": "#a7a7a7",
        "attributes": {
          "category": "color",
          "type": "secondary",
          "item": "ondark"
        },
        "filePath": "packages/Color/src/index.js",
        "isSource": true,
        "original": {
          "value": "#a7a7a7",
          "attributes": {
            "category": "color"
          }
        },
        "name": "ElementsSecondaryOndark",
        "path": [
          "elements",
          "secondary",
          "ondark"
        ]
      }
    }
  }
}